import { OrderDetails } from "hooks/OrderManagement/useOrders";
import React from "react";
import { Link } from "react-router-dom";

const ShippingInformation = ({ data }: { data?: OrderDetails }) => {
  if (!data) return null;

  return (
    <div className="border-[1px] border-[#eee] rounded-md mb-[15px]">
      <div className="border-b-[1px] border-[#eee] py-[20px] px-[15px] font-medium">
        <div className="flex justify-between items-center">
          Shipping Address
          <Link
            to={`https://google.com/maps/place/${data.customerAddress}`}
            target="_blank"
            className="text-orange flex gap-1 items-center">
            <MapIcon />
            View in Maps
          </Link>
        </div>
      </div>
      <p className="border-b-[1px] border-[#eee] py-[20px] px-[15px]">
        Delivery Method: {data.deliveryMethod}
      </p>
      <div className="py-[20px] px-[15px]">
        {data.customerName}
        <br />
        {data.customerAddress}
        <br />
        Phone: {data.customerPhone}
      </div>
    </div>
  );
};

export default ShippingInformation;

const MapIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="size-6">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z"
      />
    </svg>
  );
};
